/* Aurora patch: prevent eyesight numbers leaking into WITHOUT-eyesight items.
   Loads after aurora-luxury.js and hardens the power selects (option1/option2):
   - WITHOUT eyesight selected -> selects lose their name (not submitted) and reset to empty
   - WITH eyesight selected    -> names restored so values submit normally */
(function(){
'use strict';
function powerSelects(){
  return [document.querySelector('select.option1'),document.querySelector('select.option2')].filter(Boolean);
}
function rememberNames(){
  powerSelects().forEach(function(s){
    if(!s.hasAttribute('data-alx-name'))s.setAttribute('data-alx-name',s.getAttribute('name')||'');
  });
}
function currentEye(){
  var info=document.querySelector('.product__info-wrapper');
  if(!info)return false;
  var txt='';
  info.querySelectorAll('.product-form__input input[type="radio"]:checked').forEach(function(r){txt+=' '+(r.value||'');});
  info.querySelectorAll('.product-form__input select').forEach(function(s){txt+=' '+(s.value||'');});
  txt=txt.toLowerCase();
  if(txt.indexOf('without eyesight')>-1)return false;
  if(txt.indexOf('with eyesight')>-1)return true;
  var any='';
  info.querySelectorAll('.product-form__input input[type="radio"]').forEach(function(r){any+=' '+(r.value||'');});
  if(any.toLowerCase().indexOf('eyesight')===-1){
    var h=info.querySelector('h1');
    if(powerSelects().length&&h&&/eyesight/i.test(h.textContent))return true;
  }
  return false;
}
function sync(){
  try{
    var sels=powerSelects();
    if(!sels.length)return;
    rememberNames();
    var eye=currentEye();
    sels.forEach(function(s){
      if(eye){
        var orig=s.getAttribute('data-alx-name');
        if(orig&&s.getAttribute('name')!==orig)s.setAttribute('name',orig);
        s.disabled=false;
      }else{
        s.setAttribute('name','');
        s.disabled=true;
        if(s.value!==''){s.value='';}
      }
    });
  }catch(e){}
}
function boot(){
  if(!document.querySelector('.product__info-wrapper'))return;
  sync();
  document.addEventListener('change',function(e){
    if(!e.target)return;
    if(e.target.matches('.product-form__input input[type="radio"], .product-form__input select')||e.target.closest('.product-form__input')){
      setTimeout(sync,60);setTimeout(sync,350);
    }
  },true);
  /* final safety net right before any add-to-cart submit */
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||!f.getAttribute)return;
    if((f.getAttribute('action')||'').indexOf('/cart/add')===-1)return;
    sync();
  },true);
  var info=document.querySelector('.product__info-wrapper');
  try{new MutationObserver(function(){clearTimeout(boot.__t);boot.__t=setTimeout(sync,150);}).observe(info,{childList:true,subtree:true});}catch(e){}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
